export default __webpack_public_path__ + "static/media/sidebar-2.c50f7f60.jpg";